// Client-side "remember my last aspect-ratio selection" helpers, backed by
// localStorage. Centralized so every ad-image picker (Instant Ad Generation,
// Ads Express, Ads Express KC, Creative Tinder) behaves identically: it
// restores the user's last choice and falls back to DEFAULT_AD_ASPECT_RATIO
// (4:5) on the first visit.

import {
  type AspectRatio,
  AD_ASPECT_RATIO_STORAGE_KEY,
  AD_ASPECT_RATIOS_STORAGE_KEY,
  DEFAULT_AD_ASPECT_RATIO,
  isAspectRatio,
} from "@shared/aspectRatios";

export function loadLastAspectRatio(): AspectRatio {
  try {
    const v = localStorage.getItem(AD_ASPECT_RATIO_STORAGE_KEY);
    if (isAspectRatio(v)) return v;
  } catch {
    /* ignore (SSR / disabled storage) */
  }
  return DEFAULT_AD_ASPECT_RATIO;
}

export function saveLastAspectRatio(ratio: AspectRatio): void {
  try {
    localStorage.setItem(AD_ASPECT_RATIO_STORAGE_KEY, ratio);
  } catch {
    /* ignore */
  }
}

export function loadLastAspectRatios(): AspectRatio[] {
  try {
    const raw = localStorage.getItem(AD_ASPECT_RATIOS_STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        const valid = parsed.filter(isAspectRatio);
        if (valid.length > 0) return valid;
      }
    }
  } catch {
    /* ignore */
  }
  return [DEFAULT_AD_ASPECT_RATIO];
}

export function saveLastAspectRatios(ratios: AspectRatio[]): void {
  try {
    if (ratios.length > 0) {
      localStorage.setItem(AD_ASPECT_RATIOS_STORAGE_KEY, JSON.stringify(ratios));
    }
  } catch {
    /* ignore */
  }
}
